// extracted by mini-css-extract-plugin
export var iconContainer = "_fc-0";
export var metricCardsContainer = "_fc-1";